import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVscoComponent } from './simple-icons-vsco.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVscoComponent ],
    exports:      [ SimpleIconsVscoComponent ],
    bootstrap:    []
})
export class SimpleIconsVscoModule {}
